import { render, staticRenderFns } from "./TrackDetails.vue?vue&type=template&id=04e5749e&scoped=true"
import script from "./TrackDetails.vue?vue&type=script&lang=js"
export * from "./TrackDetails.vue?vue&type=script&lang=js"
import style0 from "./TrackDetails.vue?vue&type=style&index=0&id=04e5749e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e5749e",
  null
  
)

export default component.exports